import React, {Component} from 'react';
import {pushAnalyticsEvent} from '../../organisms/Analytics';
import {NEW_CYBERSOURCE_PAYMENT_FORM} from '../../../consts';

const REGEX_ACCEPTABLE = /^(((0[1-9]?)|(1[0-2]?))(\/[0-9]{0,4})?)?$/;

const REGEX_MONTH_PROVIDED = /^[0-9]{3}$/;

class ExpiryInputField extends Component {
    onChange = e => {
        pushAnalyticsEvent({
            interactionName: 'form tracking',
            formName: NEW_CYBERSOURCE_PAYMENT_FORM,
            formField: 'expiry-input'
        });
        const separator = '/';
        const {value} = e.target;
        const {field: {name, value: currentValue}, form: {setFieldValue}} = this.props;

        let newValue = value;

        if (value.length > currentValue.length && REGEX_MONTH_PROVIDED.test(value)) {
            newValue = value.slice(0, 2) + separator + value.slice(2);
        }

        if (!REGEX_ACCEPTABLE.test(newValue)) {
            return;
        }

        setFieldValue(name, newValue);
    }

    render() {
        const {field, form, ...restProps} = this.props;

        return (
            <input
                {...restProps}
                {...field}
                onChange={this.onChange}
                autoComplete="cc-exp"
                maxLength="5"
                type="tel"
            />
        );
    }
}

export default ExpiryInputField;
